import { IntlMessageFormat } from 'intl-messageformat';
import get from 'lodash.get';

import abTests from '#shared/util/abTests.js';
import appError from '#shared/util/appError.js';

export default {
	getLocalization: (state) => (localizationPath, localizationFormat) => {
		const localizationString = get(state.localization, localizationPath);
		if (typeof localizationString === 'string') {
			try {
				const localization = new IntlMessageFormat(localizationString, [state.url.locale, 'en-WW']);
				return localization.format(localizationFormat);
			} catch (error) {
				appError(error, {
					code: 'APP_SHARED_STORE',
					origin: 'store.getLocalization'
				});
				return '';
			}
		} else {
			appError(`Localization path ${localizationPath} not found`, {
				code: 'APP_SHARED_STORE',
				origin: 'store.getLocalization'
			});
			return '';
		}
	},
	getProduct: (state) => (productId) => {
		return state.order.products.find((product) => product.id === productId);
	},
	isCustomId(state) {
		return abTests({
			customer: state.customer,
			order: state.order,
			theme: state.theme,
			url: state.url
		});
	},
	areTermsAccepted(state) {
		return state.terms && state.terms.accepted;
	},
	hasTermsCheckbox(state) {
		return state.terms && state.terms.checkbox;
	},
	showDisclaimer(state) {
		return state.theme.variables.hasDisclaimer && state.selectedPayment && state.order && !state.order.hasBusinessProduct && !(state.selectedPayment.isManualRenewal || state.order.hasManualRenewalProduct);
	},
	enabledPaymentMethodsTypes(state) {
		return (state?.payment.paymentMethods ?? []).map((paymentMethod) => paymentMethod.id);
	},
	providerElementsLoaded(state, getters) {
		const cartIsLoaded = !state.isLoading;
		const isCreditCardEnabled = getters.enabledPaymentMethodsTypes.includes('creditCard');
		if (isCreditCardEnabled || state.selectedPayment.type === 'creditCard') {
			const creditCardSecurityCodeInputLoaded = Boolean(state.selectedPayment.cardcvv);
			const creditCardInputsLoaded = Boolean(creditCardSecurityCodeInputLoaded && state.selectedPayment.cardexpiration && state.selectedPayment.cardnumber);
			return cartIsLoaded && (state.order.isGuest || state.isNewMethod ? creditCardInputsLoaded : creditCardSecurityCodeInputLoaded);
		}
		const isDirectDebitEnabled = getters.enabledPaymentMethodsTypes.includes('directDebit');
		if (isDirectDebitEnabled || state.selectedPayment.type === 'directDebit') {
			const directDebitInputsLoaded = Boolean(state.selectedPayment.iban);
			return cartIsLoaded && directDebitInputsLoaded;
		}
		const isBancontactEnabled = getters.enabledPaymentMethodsTypes.includes('bancontact');
		if (isBancontactEnabled || state.selectedPayment.type === 'bancontact') {
			const bancontactInputsLoaded = Boolean(state.selectedPayment.cardexpiration && state.selectedPayment.cardnumber);
			return cartIsLoaded && bancontactInputsLoaded;
		}
		return cartIsLoaded;
	}
};
